/** Ana menü ve footer — temiz URL ile uyumlu (UTF-8 etiketler) */
export const primaryNavLinks = [
  { label: 'Anasayfa', to: '/' },
  { label: 'Hizmetler', to: '/hizmetler' },
  { label: 'Markalar', to: '/kombi-markalari' },
  { label: 'Neden Biz?', to: '/neden-biz' },
  { label: 'İletişim', to: '/iletisim' },
] as const;
